import React from "react";
import CountUp from "react-countup";
import Style from "../Style/AboutPage.module.scss";
import { Link, useOutletContext } from "react-router-dom";
import Sweeta from "../Img/Sweeta2.jpeg";
import saurabh from "../Img/saurabh1.jpeg";
import shreelekha from "../Img/Shreelekha.jpeg";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { motion } from "framer-motion";
import { FaInstagram, FaLinkedin } from "react-icons/fa";

const AboutPage = () => {
  const { darkMode } = useOutletContext();
  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.5 }}
      >
        <HelmetProvider>
          <Helmet>
            <title>About</title>
            <link rel="canonical" href="/about-us" />
          </Helmet>
        </HelmetProvider>
        <div className={`${Style.AboutPage} ${darkMode ? Style.dark : ""}`}>
          {/* Top Banner Section */}
          <div className={Style.wrapper}>
            <div className={Style.AboutPageGoverment}>
              <div className={Style.AboutPageGovermentLeft}>
                <div className={Style.AnimatedHeading}>
                  {"Welcome to Optimyz Learning"
                    .split(" ")
                    .map((word, index) => (
                      <span
                        key={index}
                        className={Style.AnimatedWord}
                        style={{ "--delay": `${index * 0.5}s` }}
                      >
                        {word}
                      </span>
                    ))}
                </div>
                <p>
                  At Optimyz Learning, we are passionate about helping
                  individuals transform from within — through powerful
                  communication, authentic presence, and future-ready skills.
                </p>
              </div>
              <div className={Style.AboutPageGovermentRight}>
                <img
                  src="https://thumbs.dreamstime.com/b/symbol-closing-gap-demand-supply-hand-turns-cube-changes-word-to-bridge-two-words-315903616.jpg"
                  alt="Demand and Supply Gap"
                />
              </div>
            </div>
            <div className={Style.AboutPageWoner}>
              <div className={Style.AboutPageWonerLeft}>
                <h2>Ms. Shreelekha Anurag</h2>
                <h3>Co-Founder | Director | Chief Learning Officer</h3>
                <p>
                  An award-winning Soft Skills Trainer, Image Consultant, and
                  Pageant Coach, Shreelekha brings over a decade of experience
                  in the fashion retail and training industry. A NIFT alumna and
                  visiting faculty, she is known for her energetic sessions,
                  transformative approach, and deep understanding of both
                  personality development and professional etiquette.
                </p>
                <p>Certified by ICBI, NIST, and NABET</p>
                <p>Grooming partner for Miss India Dreams 2025</p>
                <p>
                  Expert in public speaking, image management & life skills
                  coaching
                </p>
                <p>
                  Her vision is simple: to help people become confident global
                  citizens with the right skills and presence.
                </p>
                <div className={Style.AboutPageWonerInsta}>
                  <Link
                    to="https://www.instagram.com/skillsandstylebyshreelekha?igsh=MXR4NTdvd2ZuZzNxaQ=="
                    target="_blank"
                  >
                    <FaInstagram size={35} color="#E4405F" />
                  </Link>
                  <Link
                    to="https://www.linkedin.com/in/shreelekha-anurag-206359b3?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                    target="_blank"
                  >
                    <FaLinkedin size={35} color="#0A66C2" />
                  </Link>
                </div>
              </div>
              <div className={Style.AboutPageWonerRight}>
                <img src={shreelekha} alt="Woner" />
              </div>
            </div>
            <div className={Style.AboutPageWonerSa}>
              <div className={Style.AboutPageWonerSaRight}>
                <img src={saurabh} alt="Woner" />
              </div>
              <div className={Style.AboutPageWonerSaLeft}>
                <h2> Mr Saurabh Sinha</h2>
                <h3>Co-Founder | Director | Chief Strategy Officer</h3>
                <p>
                  A Marine Engineer by profession and a certified Soft Skills
                  Trainer by passion, Saurabh bridges the world of technical
                  precision with human development. His international exposure
                  and shipboard leadership experience bring a global perspective
                  to the way skills are taught, learned, and applied.
                </p>
                <h3>
                  He strongly believes in: “Discipline is the foundation of
                  success—at sea or on land.”
                </h3>
                <div className={Style.AboutPageWonerInsta}>
                  <Link
                    to=""
                    target="_blank"
                  >
                    <FaInstagram size={35} color="#E4405F" />
                  </Link>
                  <Link
                    to="https://www.linkedin.com/in/saurabh-sinha-a8b46632?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                    target="_blank"
                  >
                    <FaLinkedin size={35} color="#0A66C2" />
                  </Link>
                </div>
              </div>
            </div>
            <div className={Style.AboutPageWoner1}>
              <div className={Style.AboutPageWonerLeft1}>
                <h2>Ms. Sweta Sinha</h2>
                <h3>Chief Advisor – Mindset & Life Skills</h3>
                <p>
                  Sweta is a multifaceted expert, excelling as a soft skills
                  trainer, image consultant, mindset mentor, Level 3 Reiki
                  Master, and published author of "Personal Growth Digest". With
                  a strong background in client relations and learner engagement
                  as a Customer Success Specialist in the EdTech industry, she
                  crafts impactful learning experiences.
                </p>
                <p>
                  As a strategic advisor and empaneled expert with Optimyz
                  Learning, Sweta contributes to mindset and personal
                  transformation workshops. Her mantra, "Dream, Believe,
                  Achieve," inspires her work. A change maker at heart, Sweta
                  aims to contribute to the vision of Viksit Bharat by 2047,
                  empowering individuals towards a brighter future.
                </p>
                <div className={Style.AboutPageWonerInsta}>
                  <Link
                    to="https://www.instagram.com/swetabeyondlimits?igsh=MWY0aGJ5Z3V1b2UyZw=="
                    target="_blank"
                  >
                    <FaInstagram size={35} color="#E4405F" />
                  </Link>
                  <Link
                    to="https://www.linkedin.com/in/sweta-sinha-27abb029?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                    target="_blank"
                  >
                    <FaLinkedin size={35} color="#0A66C2" />
                  </Link>
                </div>
              </div>
              <div className={Style.AboutPageWonerRight1}>
                <img src={Sweeta} alt="Woner" />
              </div>
            </div>

            <div className={Style.AboutPageVission}>
              <div className={Style.AboutPageVissionLeft}>
                <img
                  src="https://www.jaincollege.ac.in/theme/assets/images/vision20a.png"
                  alt="Vision"
                />
              </div>
              <div className={Style.AboutPageVissionRight}>
                <h2>Our Vision</h2>
                <p>
                  To become a trusted catalyst in personal and professional
                  transformation by nurturing confident, conscious, and
                  future-ready individuals
                </p>
              </div>
            </div>

            <div className={Style.AboutPageMission}>
              <div className={Style.AboutPageMissionLeft}>
                <img
                  src="https://www.jaincollege.ac.in/theme/assets/images/mission20a.png"
                  alt="Mission"
                />
              </div>
              <div className={Style.AboutPageMissionRight}>
                <h2>Our Mission</h2>
                <p>
                  At Optimyz Learning, our mission is to empower learners of all
                  ages to unlock their fullest potential through immersive,
                  value-driven training in soft skills, image management, and
                  mindset development. We strive to create impactful learning
                  journeys that spark evolution, build confidence, and inspire
                  leadership.
                </p>
              </div>
            </div>

            <div className={Style.AboutPageStats}>
              <div className={Style.StatItem}>
                <h3>
                  <CountUp start={0} end={1000} duration={2.5} separator="," />+
                </h3>
                <p>STUDENTS TRAINED</p>
              </div>
              <div className={Style.StatItem}>
                <h3>
                  <CountUp start={0} end={750} duration={2} separator="," />+
                </h3>
                <p>TRAINING HRs</p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default AboutPage;
